// src/components/LeftInformationPanel.js
import React from "react";
import "../styles/LeftInformationPanel.css";

export default function LeftInformationPanel() {
  return (
    <aside className="left-info-panel">
      <h3>Feel at home with New Way Trucking!</h3>
      <p>
        New Way Trucking is a multi-provincial transportation company operating
        throughout Canada and the United States. Our staff enjoys secure and
        consistent employment hauling freight for a number of the world’s most
        prominent Fortune 500 companies.
      </p>
      <p>
        New Way Trucking has a new and well-maintained fleet to serve our
        clients and convenience our employees.
      </p>
      <p>
        We offer a competitive pay package with safety and performance
        incentives, benefits, vacation pay as well as a good home and work-life
        balance.
      </p>
      <p>
        If you are looking for a position with a well-established transportation
        company, with great growth potential here’s your chance to join our
        team!
      </p>
    </aside>
  );
}
